"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@mui/material");
require("./TextAnswer.css");
var _react = require("react");
var _ValidationFormat = require("../../../../utility/Forms/ValidationFormat");
var _reactNumberFormat = require("react-number-format");
var _jsxRuntime = require("react/jsx-runtime");
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var TextAnswer = function TextAnswer(props) {
  var _useState = (0, _react.useState)(props.existingAnswerValue),
    _useState2 = _slicedToArray(_useState, 2),
    existingAnswerValue = _useState2[0],
    setExistingAnswerValue = _useState2[1];
  var _useState3 = (0, _react.useState)(props.invalidAnswerSubmitted),
    _useState4 = _slicedToArray(_useState3, 2),
    invalidAnswerSubmitted = _useState4[0],
    setInvalidAnswerSubmitted = _useState4[1];
  var _useState5 = (0, _react.useState)(props.existingAnswerValue),
    _useState6 = _slicedToArray(_useState5, 2),
    answer = _useState6[0],
    setAnswer = _useState6[1];
  var _useState7 = (0, _react.useState)(props.didSubmitAnswer),
    _useState8 = _slicedToArray(_useState7, 2),
    didSubmitAnswer = _useState8[0],
    setDidSubmitAnswer = _useState8[1];
  var _useState9 = (0, _react.useState)(props.existingAnswerValue),
    _useState10 = _slicedToArray(_useState9, 2),
    previouslySubmittedAnswer = _useState10[0],
    setPreviouslySubmittedAnswer = _useState10[1];

  // Set the default value as the answer if no other answer has been provided
  (0, _react.useEffect)(function () {
    if (props.data.defaultValue && !answer) {
      var defaultAnswer = props.interpolate(props.data.defaultValue);
      if (props.data.validationFormat === _ValidationFormat.ValidationFormat.Currency || props.data.validationFormat === _ValidationFormat.ValidationFormat.Number) {
        defaultAnswer = defaultAnswer.replaceAll(",", "");
        defaultAnswer = defaultAnswer.replaceAll("$", "");
        defaultAnswer = Number(defaultAnswer);
      }
      setAnswer(defaultAnswer);
    }
  }, []);
  (0, _react.useEffect)(function () {
    if (invalidAnswerSubmitted !== props.invalidAnswerSubmitted) {
      setInvalidAnswerSubmitted(props.invalidAnswerSubmitted);
      setDidSubmitAnswer(false);
    }
    if (existingAnswerValue !== props.existingAnswerValue) {
      setExistingAnswerValue(props.existingAnswerValue);
    }
    if (didSubmitAnswer !== props.didSubmitAnswer) {
      setDidSubmitAnswer(props.didSubmitAnswer);
    }
  }, [props.invalidAnswerSubmitted, props.existingAnswerValue, props.didSubmitAnswer]);
  (0, _react.useEffect)(function () {
    if (previouslySubmittedAnswer !== answer || didSubmitAnswer) {
      props.setAnswer(props.data.id, answer, didSubmitAnswer);
      setPreviouslySubmittedAnswer(answer);
    }
  }, [answer, didSubmitAnswer]);
  function checkForSubmittedAnswerOrNewAnswerBeingTyped(event) {
    if (event.target.value !== answer) {
      var _answer = event.target.value;
      if (props.data.validationFormat === _ValidationFormat.ValidationFormat.Currency || props.data.validationFormat === _ValidationFormat.ValidationFormat.Number) {
        _answer = _answer.replaceAll(",", "");
        _answer = Number(_answer);
      }
      setAnswer(_answer);
    }
    if (event.key.toLowerCase() === "enter") {
      setDidSubmitAnswer(true);
    }
  }
  function getPlaceholder() {
    if (props.placeholder) {
      return props.placeholder;
    }
    if (props.data.placeholder) {
      return props.data.placeholder;
    }
    switch (props.data.validationFormat) {
      case _ValidationFormat.ValidationFormat.Email:
        return "name@company.com";
      case _ValidationFormat.ValidationFormat.PhoneNumber:
        return "555-555-5555";
      case _ValidationFormat.ValidationFormat.ZipCode:
        return "12345";
      case _ValidationFormat.ValidationFormat.Currency:
        return "123,456";
      case _ValidationFormat.ValidationFormat.Number:
        return "100";
      default:
        return "Type your answer here...";
    }
  }
  function getInputType() {
    switch (props.data.validationFormat) {
      case _ValidationFormat.ValidationFormat.Email:
        return "email";
      case _ValidationFormat.ValidationFormat.PhoneNumber:
        return "tel";
      case _ValidationFormat.ValidationFormat.ZipCode:
        return "text";
      // Because we are using NumericFormat, we do not want to use the built-in "number" type here
      case _ValidationFormat.ValidationFormat.Currency:
        return "text";
      case _ValidationFormat.ValidationFormat.Number:
        return "text";
      default:
        return "text";
    }
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: "text-answer",
    children: props.data.validationFormat === _ValidationFormat.ValidationFormat.Currency || props.data.validationFormat === _ValidationFormat.ValidationFormat.Number ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactNumberFormat.NumericFormat, {
      value: answer,
      customInput: _material.TextField,
      thousandSeparator: ",",
      decimalSeparator: ".",
      autoFocus: true,
      className: "text-input-answer",
      placeholder: getPlaceholder(),
      variant: props.variant || "standard",
      onKeyUp: checkForSubmittedAnswerOrNewAnswerBeingTyped,
      defaultValue: existingAnswerValue || props.interpolate(props.data.defaultValue),
      name: props.data.name,
      type: getInputType(),
      error: invalidAnswerSubmitted,
      InputProps: props.data.validationFormat === _ValidationFormat.ValidationFormat.Currency ? {
        startAdornment: /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.InputAdornment, {
          position: "start",
          children: props.currencySymbol || "$"
        })
      } : null
    }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.TextField, {
      autoFocus: true,
      className: "text-input-answer ".concat(props.data.validationFormat === _ValidationFormat.ValidationFormat.Currency ? "align-right" : ""),
      placeholder: getPlaceholder(),
      variant: props.variant || "standard",
      onKeyUp: checkForSubmittedAnswerOrNewAnswerBeingTyped,
      defaultValue: existingAnswerValue,
      name: props.data.name,
      type: getInputType(),
      error: invalidAnswerSubmitted
    })
  });
};
var _default = TextAnswer;
exports.default = _default;